import { useState } from 'react'
import TimeWindow from '../../services/timeWindow'
import BusinessNavbar from '../../components/Navbars/BusinessNavbar'
import ItemTabs from '../../components/ItemTabs'
import Select from '../../components/Inputs/Select'
import Earnings from './Earnings'
import Sales from './Sales'
import Reports from './Reports'
import Heatmap from './Heatmap'
import { DateTime } from 'luxon'

import {
  Container,
  FilterContainer,
  TabStickyContainer,
  Title
} from './styles'
  
export default function Dashboard () {
  const OPTION_LIST = [
    { label: 'Rendimentos', value: 'earnings' },
    { label: 'Vendas', value: 'sales' },
    { label: 'Relatórios', value: 'reports' },
    { label: 'Mapa de calor', value: 'heatmap' }
  ]
  
  const now = DateTime.now ().setLocale ('pt-BR')
  const [option, setOption] = useState (OPTION_LIST[0])
  const [month, setMonth] = useState ({
    label: now.toFormat ('MMMM'),
    value: now.month
  })
  const [year, setYear] = useState ({
    label: now.toFormat ('yyyy'),
    value: now.year
  })

  const renderTabComponent = () => {
    switch (option.value) {
      case 'earnings':
        return <Earnings month={month} year={year}/>
      case 'sales':
        return <Sales month={month} year={year}/>
      case 'reports':
        return <Reports/>
      case 'heatmap':
        return <Heatmap/>
      default:
        return null
    }
  }

  return (
    <Container>
      <BusinessNavbar/>
      <Title>Painel de estatísticas do salão</Title>
      <TabStickyContainer>
        <ItemTabs
          tabs={OPTION_LIST}
          selectedTab={option.value}
          onTabChange={(value) => setOption(OPTION_LIST.find(o => o.value === value))}
          tabWidth={160}
        />
      </TabStickyContainer>
      <FilterContainer style={{marginTop: 0, marginBottom: 20}}>
        <Select
          options={TimeWindow.getMonths ()}
          value={month}
          onChange={(_, value) => setMonth (value)}
        />
        <Select
          options={TimeWindow.getYears ('2021', now.year.toString ())}
          value={year}
          onChange={(_, value) => setYear (value)}
        />
      </FilterContainer>
      {renderTabComponent ()}
    </Container>
  )
}
